import axios from "axios";
import { getTeacherToken } from "./authStorage";

let onUnauthorized = null;
export function setOnUnauthorized(fn) {
    onUnauthorized = fn;
}

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
    const token = getTeacherToken();

    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

api.interceptors.response.use(
    (res) => res,
    (err) => {
        if (err?.response?.status === 401) {
            if (typeof onUnauthorized === "function") onUnauthorized();
        }
        return Promise.reject(err);
    }
);

export default api;
